import React from "react";

const EmptyState = ({ title = "Nothing here yet", description, action, icon }) => (
    <div className="relative flex flex-col items-center justify-center overflow-hidden rounded-2xl border border-dashed border-zinc-200 bg-zinc-50/60 p-12 text-center dark:border-white/10 dark:bg-white/[0.03]" data-testid="empty-state">
        {/* Subtle PILLS watermark */}
        <img
            src="/pills-logo.jpg"
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute -right-6 -top-6 h-28 w-28 rotate-12 rounded-2xl object-cover opacity-[0.06]"
        />
        {icon ? <div className="mb-4 text-zinc-400">{icon}</div> : null}
        <h3 className="relative text-base font-medium text-zinc-900 dark:text-zinc-50">{title}</h3>
        {description ? <p className="relative mt-1 max-w-md text-sm text-zinc-500 dark:text-zinc-400">{description}</p> : null}
        {action ? <div className="relative mt-5">{action}</div> : null}
    </div>
);

export default EmptyState;
